import React, { useState } from "react";

function JwtDisplayBox({ jwt }) {
  const [visible, setVisible] = useState(false);
  const masked = jwt.replace(/./g, "•");

  return (
    <div style={{ marginTop: "25px" }}>
      <label className="form-label">Generated JWT</label>

      <div className="jwt-box">
        {visible ? jwt : masked}

        {/* Show / Hide Icon */}
        <svg
          onClick={() => setVisible(!visible)}
          className="icon-btn"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
        >
          {visible ? (
            <path
              d="M2 2L22 22"
              stroke="#333"
              strokeWidth="2"
              strokeLinecap="round"
            />
          ) : (
            <path
              d="M12 5C7 5 2.7 8.1 1 12c1.7 3.9 6 7 11 7s9.3-3.1 11-7c-1.7-3.9-6-7-11-7z"
              stroke="#333"
              strokeWidth="2"
            />
          )}
        </svg>

        {/* Copy Icon */}
        <svg
          onClick={() => navigator.clipboard.writeText(jwt)}
          className="icon-btn copy-btn"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
        >
          <rect
            x="9"
            y="9"
            width="13"
            height="13"
            rx="2"
            stroke="#333"
            strokeWidth="2"
          />
          <rect
            x="3"
            y="3"
            width="13"
            height="13"
            rx="2"
            stroke="#333"
            strokeWidth="2"
          />
        </svg>
      </div>
    </div>
  );
}

export default JwtDisplayBox;
